import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import { Provider } from "react-redux";
import { persistor, store } from "./store/store.ts";
import { RouterProvider } from "react-router-dom";
import { router } from "./router/index.tsx";
import "@/i18n";
import { ThemeProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";
import { PersistGate } from "redux-persist/integration/react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { PasswordConfirmProvider } from "./context/PasswordConfirmContext.tsx";

createRoot(document.getElementById("root")!).render(
  <GoogleOAuthProvider clientId="824682521765-8u8n4boq0krug9v35stcp4un1uu4rves.apps.googleusercontent.com">
    <StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Provider store={store}>
          <PasswordConfirmProvider>
            <PersistGate loading={null} persistor={persistor}>
              <RouterProvider router={router} />
            </PersistGate>
          </PasswordConfirmProvider>
        </Provider>
      </ThemeProvider>
    </StrictMode>
  </GoogleOAuthProvider>
);
